import { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import { isPreviewHost, isNetworkError } from "@/lib/authErrors";

const PUBLISHED_URL = "https://permuta-87.lovable.app";
const STORAGE_KEY = "preview-network-banner-dismissed";

/**
 * Banner único e discreto exibido apenas em hostname Preview quando
 * algum erro de rede do Supabase é detectado. Permite dispensar.
 */
const PreviewNetworkBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isPreviewHost()) return;
    if (sessionStorage.getItem(STORAGE_KEY) === "1") return;

    const trigger = () => setVisible(true);

    const onError = (e: ErrorEvent) => {
      if (isNetworkError(e.error) || isNetworkError(e.message)) trigger();
    };
    const onRejection = (e: PromiseRejectionEvent) => {
      if (isNetworkError(e.reason)) trigger();
    };

    window.addEventListener("error", onError);
    window.addEventListener("unhandledrejection", onRejection);

    return () => {
      window.removeEventListener("error", onError);
      window.removeEventListener("unhandledrejection", onRejection);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-[100] bg-amber-50 border-b border-amber-200 text-amber-900 text-sm">
      <div className="mx-auto max-w-6xl px-4 py-2 flex items-center gap-3">
        <AlertTriangle size={16} className="shrink-0" />
        <p className="flex-1">
          Ambiente Preview — alguns recursos podem não funcionar.{" "}
          <a
            href={PUBLISHED_URL}
            className="underline font-medium"
            target="_blank"
            rel="noopener noreferrer"
          >
            Acesse o site publicado
          </a>{" "}
          para usar com normalidade.
        </p>
        <button
          type="button"
          onClick={() => {
            sessionStorage.setItem(STORAGE_KEY, "1");
            setVisible(false);
          }}
          className="p-1 hover:bg-amber-100 rounded"
          aria-label="Fechar aviso"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default PreviewNetworkBanner;